import { render } from "./Page.vue?vue&type=template&id=1e3738d1&scoped=true"
import script from "./Page.js?vue&type=script&lang=js"
export * from "./Page.js?vue&type=script&lang=js"

import "./Page.scss?vue&type=style&index=0&id=1e3738d1&lang=scss&scoped=true"

import exportComponent from "/Users/jiangxin/xhw/outer-h5-gwj-nft-website-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3738d1"]])

export default __exports__